import ReactMarkdown from 'react-markdown';
export function Markdown({ children }: { children?: string | null }) { return <ReactMarkdown>{children || ''}</ReactMarkdown>; }
